export default __webpack_public_path__ + "static/media/465.affbd308.png";